import ProductElement from 'umg-ember-backend/components/record-explorer/for/product-element';

<template>
  <ProductElement @records={{@model}} @recordType='product-element' />
</template>
